<template>
  <div class="main hostList">
    <div class="nav">
      <div class="left">
        <div @click="$router.go(-1)" class="icon_back"></div>
      </div>
      {{ titleName }}
    </div>
    <div class="content">
      <div>
        <van-list v-model="loading" :finished="finished" @load="faechPage">
          <van-cell
            v-for="(item, index) in VideoList"
            :key="index"
            class="list_item"
          >
            <div
              class="hotDLista"
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <div class="img_info_user">
                <viewer class="img_viewer">
                  <img :src="item.anchor_img" />
                </viewer>
              </div>
              <div class="list_details">
                <router-link
                  :to="{
                    path: '/hosDetails',
                    query: {
                      sid: queryData.sid,
                      aid: item.aid,
                      platform: $route.query.platform,
                    },
                  }"
                >
                  <p>{{ item.anchor_name }}</p>
                  <p>{{ item.anchor_desc }}</p>
                </router-link>
              </div>
              <!-- <div class="btn_attention">
                        <div v-if="item.anchor_is == 2" @click="attention(item)">+ 关注</div>
                        <div v-if="item.anchor_is == 1" @click="attention(item)" class="active">已关注</div>
                    </div> -->
            </div>
          </van-cell>
        </van-list>
      </div>
      <div
        v-if="!loading && finished"
        class="No_more"
        style="text-align: center"
      >
        我也是有底线的
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import "../css/hostList.scss";
export default {
  name: "",
  data() {
    return {
      VideoList: [],
      titleName: "",
      listParams: {
        page: 0,
        pageSize: 10,
      },
      loading: false,
      finished: false,
    };
  },
  computed: {},
  watch: {
    $route(to, from) {
      if (to) {
        this.finished = true;
        this.listParams.page = 1;
        this.listParams.pageSize = 10;
        // 默认清空
        this.VideoList = [];
        this.getAllList();
      }
    },
  },
  created() {
    this.titleName = this.$route.query.name;
    this.queryData = this.$route.query || {};
    let query = this.$route.query;
    // this.fetchColumnMore(query).then(res =>{
    //   // console.log(res)
    //   this.MoreList = res.data
    // })
  },
  methods: {
    ...mapActions("userIndex", ["fetchColumnMore", "fetchAttention"]),
    getAllList() {
      this.loading = true;
      this.listParams.sid = this.$route.query.sid;
      this.fetchColumnMore(this.listParams).then((res) => {
        console.log(res.data);
        this.loading = false;
        if (!res.data || res.data == "") {
          this.finished = true;
          return false;
        }
        this.finished = false;
        this.VideoList = res.data;
      });
    },
    faechPage() {
      this.listParams.page++;
      this.loading = true;
      this.listParams.sid = this.$route.query.sid;
      this.fetchColumnMore(this.listParams).then((res) => {
        // console.log(res.data)
        this.loading = false;
        if (!res.data || res.data == "") {
          this.finished = true;
          return false;
        }
        this.VideoList = this.VideoList.concat(res.data);
      });
    },
    attention(item) {
      let query = this.$route.query;
      if (item.anchor_is == 2) {
        let obj = {
          aid: item.aid,
          type: 1,
        };
        this.fetchAttention(obj).then((res) => {
          if (res.code == 200) {
            this.$dialog({
              message: "关注成功",
            }).then(() => {});
            this.fetchColumnMore(query).then((res) => {
              console.log(res);
              this.VideoList = res.data;
            });
          } else {
            this.$dialog
              .confirm({
                message: "登录后才能关注",
              })
              .then(() => {
                this.$router.push({
                  path: "/login",
                  query: {
                    platform: this.$route.query.platform,
                  },
                });
              });
          }
        });
      } else {
        let obj = {
          aid: item.aid,
          type: 2,
        };
        this.fetchAttention(obj).then((res) => {
          if (res.code == 200) {
            this.$dialog({
              message: "取消关注成功",
            }).then(() => {});
            this.fetchColumnMore(query).then((res) => {
              this.VideoList = res.data;
            });
          } else {
            this.$dialog
              .confirm({
                message: "登录后才能关注",
              })
              .then(() => {
                this.$router.push({
                  path: "/login",
                  query: {
                    platform: this.$route.query.platform,
                  },
                });
              });
          }
        });
      }
    },
  },
};
</script>
